import actionTypes from "../../constants/constants";

const INITIAL_STATE = {};

export default (states = INITIAL_STATE, action) => {
	switch (action.type) {
		case actionTypes.CLOUDSTORAGECONFIGURATION: {
			return ({
				...action.payload
			});
		}
			
		default:
			return states;
	}
}